import { Button } from "@/components/ui/Button";
import { Dialog, DialogFooter } from "@/components/ui/Dialog";
import { t } from "@/lib/strings";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: "default" | "danger";
  busy?: boolean;
  onConfirm: () => void;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  message,
  confirmLabel,
  cancelLabel,
  tone = "default",
  busy = false,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={title} description={message} width={420}>
      <DialogFooter>
        <Button
          type="button"
          variant="ghost"
          size="md"
          onClick={() => onOpenChange(false)}
          disabled={busy}
        >
          {cancelLabel ?? t.cancel}
        </Button>
        <Button
          type="button"
          variant={tone === "danger" ? "destructive" : "primary"}
          size="md"
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? t.loading : (confirmLabel ?? t.confirm)}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
